import ClickAwayListener from '@mui/material/ClickAwayListener';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import { tooltipStyle, tooltipWithHoverStyle } from './MiViewTooltip.style';

type MiViewTooltipProps = TooltipProps & {
  handleTooltipClosing?: () => void;
  open?: boolean;
  followCursor?: boolean;
};

const MiViewTooltip = styled(
  ({ className, handleTooltipClosing, open, ...props }: MiViewTooltipProps) => (
    open ? (
      <ClickAwayListener onClickAway={ () => handleTooltipClosing?.() }>
        <Tooltip
          { ...props }
          open={ open }
          classes={ { popper: className } }
          PopperProps={ { modifiers: [{ name: 'flip', enabled: false }] } }
        />
      </ClickAwayListener>
    ) : (
      <Tooltip
        { ...props }
        open={ open }
        classes={ { popper: className } }
        PopperProps={ { modifiers: [{ name: 'flip', enabled: false }] } }
      />
    )
  ),
)(({ followCursor }: { followCursor?: boolean }) => ({
  ...(followCursor ? tooltipWithHoverStyle : tooltipStyle),
}));

export default MiViewTooltip;
